"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessage = void 0;

var _react = _interopRequireWildcard(require("react"));

var _basis = require("basis");

var _hooks = require("../../hooks");

var _types = require("../../types");

var _errorWhitelist = require("../../constants/errorWhitelist");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-ignore
var ErrorMessage = function ErrorMessage(props) {
  var error = props.error,
      errorCode = props.errorCode,
      additionalErrorMessage = props.additionalErrorMessage,
      _props$useOnEvent = props.useOnEvent,
      useOnEvent = _props$useOnEvent === void 0 ? _hooks.useOnEvent : _props$useOnEvent;
  var onEvent = useOnEvent();
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (error) {
      ref.current && ref.current.scrollIntoView(true);
      onEvent({
        type: _types.FiConnectEventTypes.ERROR,
        error: error,
        errorCode: errorCode
      });
    }
  }, [error, errorCode, onEvent]);

  if (!(0, _errorWhitelist.isWhitelistedError)(errorCode)) {
    return null;
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: ref
    }, /*#__PURE__*/_react.default.createElement(_basis.Message, {
      severity: "warning-or-significant",
      bg: "secondary.pink.t30",
      children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, error, additionalErrorMessage),
      testId: "error-message"
    }));
  }
};

exports.ErrorMessage = ErrorMessage;